import { handleActions } from 'redux-actions';
import { Actions, LoadUserFailPayload } from '../constants';

export type State = Readonly<{
  errors: object[];
  isNotFound: boolean;
  loading: boolean;
}>;

export const initialState: State = {
  errors: [],
  isNotFound: false,
  loading: false,
};

const loadStateReducer = handleActions(
  {
    [Actions.LOAD_USER_START]: () => ({
      loading: true,
      isNotFound: false,
      errors: [],
    }),
    [Actions.LOAD_USER_DONE]: () => ({
      errors: [],
      isNotFound: false,
      loading: false,
    }),
    [Actions.LOAD_USER_FAIL]: (_state, action: LoadUserFailPayload) => ({
      errors: action.payload.errors,
      isNotFound: action.payload.isNotFound,
      loading: false,
    }),
  },
  initialState,
);
export { loadStateReducer };
